// extracted by mini-css-extract-plugin
export default {"card":"Card_card__mqveB","cardDetail":"Card_cardDetail__L-2R+","cardTitle":"Card_cardTitle__CweVr","cardDescription":"Card_cardDescription__RxK7q"};